import React from "react";
import PropTypes from "prop-types";

// Poistka proti prazdnej obrazovke.
//
// Ked v Reacte spadne jedina sucast, zhasne cela stranka a clovek vidi bielu
// alebo ciernu plochu bez jedineho slova. Z toho sa neda zistit nic a hlasi
// sa to ako "nefunguje to". Tato hranica chybu zachyti, zvysok administracie
// bezi dalej a na mieste rozbitej casti je text, ktory sa da odfotit a poslat.
class HraniceChyby extends React.Component {
  constructor(props) {
    super(props);
    this.state = { chyba: null, kde: null };
  }

  static getDerivedStateFromError(chyba) {
    return { chyba };
  }

  componentDidCatch(chyba, info) {
    this.setState({ kde: info?.componentStack || null });
    // Nech je to aj v konzole prehliadaca, odtial sa da skopirovat cele.
    console.error("[ADMIN] nezachytena chyba:", chyba, info);
  }

  render() {
    const { chyba, kde } = this.state;
    if (!chyba) {
      return this.props.children;
    }
    return (
      <div
        style={{
          margin: "24px",
          padding: "20px 24px",
          border: "1.5px solid #ff4d4f",
          background: "#fff5f5",
          borderRadius: "10px",
          color: "#1a1a1a",
        }}
      >
        <h3 style={{ marginTop: 0 }}>Táto časť sa nepodarilo zobraziť</h3>
        <p style={{ margin: "6px 0 14px" }}>
          Zvyšok administrácie funguje ďalej. Odfoťte prosím text nižšie a
          pošlite ho, podľa neho sa chyba opraví.
        </p>
        <pre
          style={{
            whiteSpace: "pre-wrap",
            fontSize: "12px",
            background: "#fff",
            border: "1px solid #ffd6d6",
            borderRadius: "6px",
            padding: "10px",
            maxHeight: "260px",
            overflow: "auto",
          }}
        >
          {String(chyba && (chyba.stack || chyba.message || chyba))}
          {kde ? "\n--- kde ---" + kde : ""}
        </pre>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            marginTop: "12px",
            padding: "10px 18px",
            border: "none",
            borderRadius: "6px",
            background: "#5f63f2",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Načítať znova
        </button>
      </div>
    );
  }
}

HraniceChyby.propTypes = {
  children: PropTypes.node,
};

export { HraniceChyby };
export default HraniceChyby;
